var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievementShowroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207.94 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fed442;\n      }\n\n      .cls-2 {\n        fill: #fec633;\n      }\n\n      .cls-3 {\n        fill: #fece3c;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-6 {\n        fill: #feedb4;\n      }\n\n      .cls-7 {\n        fill: #feb51f;\n      }\n\n      .cls-8, .cls-9 {\n        fill: #0a2445;\n      }\n\n      .cls-10 {\n        fill: #fece3b;\n      }\n\n      .cls-11 {\n        fill: #fec734;\n      }\n\n      .cls-12 {\n        fill: #fec42f;\n      }\n\n      .cls-13 {\n        fill: #febb25;\n      }\n\n      .cls-14 {\n        opacity: .5;\n      }\n\n      .cls-15 {\n        fill: #37474f;\n      }\n\n      .cls-16 {\n        fill: #feb620;\n      }\n\n      .cls-17 {\n        fill: #455a64;\n      }\n\n      .cls-18 {\n        fill: #fec32e;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-20 {\n        fill: #a6a6a6;\n      }\n\n      .cls-21, .cls-22 {\n        isolation: isolate;\n      }\n\n      .cls-23 {\n        fill: #fec22d;\n      }\n\n      .cls-24 {\n        opacity: .33;\n      }\n\n      .cls-25 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-25, .cls-26 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-27 {\n        fill: #fecb38;\n      }\n\n      .cls-28 {\n        opacity: .66;\n      }\n\n      .cls-28, .cls-29 {\n        fill: #263238;\n      }\n\n      .cls-30 {\n        fill: #fbd037;\n      }\n\n      .cls-30, .cls-6, .cls-31, .cls-9, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37 {\n        fill-rule: evenodd;\n      }\n\n      .cls-38 {\n        fill: #fed13f;\n      }\n\n      .cls-39 {\n        fill: #fed745;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-41 {\n        fill: #fed543;\n      }\n\n      .cls-42 {\n        fill: #fec631;\n      }\n\n      .cls-43 {\n        fill: #feb923;\n      }\n\n      .cls-44 {\n        fill: #feb721;\n      }\n\n      .cls-45 {\n        mix-blend-mode: multiply;\n        opacity: .15;\n      }\n\n      .cls-46 {\n        fill: #febe28;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-50 {\n        fill: #fec12c;\n      }\n\n      .cls-51 {\n        fill: #fed847;\n      }\n\n      .cls-52 {\n        fill: #feca37;\n      }\n\n      .cls-53 {\n        fill: #febf2a;\n      }\n\n      .cls-54 {\n        fill: #febe29;\n      }\n\n      .cls-55 {\n        opacity: .75;\n      }\n\n      .cls-56 {\n        fill: #fec530;\n      }\n\n      .cls-57 {\n        fill: #fed644;\n      }\n\n      .cls-58 {\n        fill: #feb41d;\n      }\n\n      .cls-59 {\n        fill: #feb21b;\n      }\n\n      .cls-31 {\n        fill: #fac405;\n      }\n\n      .cls-60 {\n        fill: #fedb4a;\n      }\n\n      .cls-61 {\n        fill: #fed03e;\n      }\n\n      .cls-62 {\n        fill: #fed341;\n      }\n\n      .cls-63 {\n        fill: #fec02b;\n      }\n\n      .cls-64, .cls-35 {\n        fill: #fbcb22;\n      }\n\n      .cls-32 {\n        fill: #fde89b;\n      }\n\n      .cls-65 {\n        fill: #fec835;\n      }\n\n      .cls-33 {\n        fill: #805900;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-67 {\n        fill: #feb822;\n      }\n\n      .cls-68 {\n        fill: #ebebeb;\n      }\n\n      .cls-69 {\n        fill: #ffc727;\n      }\n\n      .cls-70, .cls-22 {\n        opacity: .1;\n      }\n\n      .cls-71 {\n        fill: #feb11a;\n      }\n\n      .cls-72 {\n        fill: none;\n      }\n\n      .cls-73 {\n        fill: #fed240;\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-75 {\n        fill: #febd27;\n      }\n\n      .cls-34, .cls-76 {\n        fill: #eca400;\n      }\n\n      .cls-77 {\n        fill: #feb51e;\n      }\n\n      .cls-78 {\n        fill: #fecf3d;\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-80, .cls-36 {\n        fill: #fde282;\n      }\n\n      .cls-81 {\n        fill: #fed746;\n      }\n\n      .cls-82 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-83 {\n        fill: #febc26;\n      }\n\n      .cls-84 {\n        fill: #cc8e00;\n      }\n\n      .cls-85 {\n        fill: #feb31c;\n      }\n\n      .cls-86 {\n        fill: #7329e8;\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-88 {\n        fill: #feda49;\n      }\n\n      .cls-89 {\n        fill: #fecc39;\n      }\n\n      .cls-90 {\n        fill: #fec936;\n      }\n\n      .cls-91 {\n        fill: #fed948;\n      }\n\n      .cls-37 {\n        fill: #8fa3bc;\n      }\n\n      .cls-92 {\n        fill: #fecd3a;\n      }\n\n      .cls-93 {\n        fill: #feba24;\n      }\n\n      .cls-94 {\n        fill: #442491;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 18.67,
    y: 200.64,
    width: 109.35,
    height: 81.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 89.16,
    y1: 155.97,
    x2: 136.65,
    y2: 155.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb11a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedb4a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m115.66,136.05h-5.52c-5.41,0-10.41,2.89-13.12,7.57l-2.76,4.78c-2.71,4.69-2.71,10.46,0,15.15l2.76,4.78c2.71,4.69,7.71,7.57,13.12,7.57h5.52c5.41,0,10.41-2.89,13.12-7.57l2.76-4.78c2.71-4.69,2.71-10.46,0-15.15l-2.76-4.78c-2.71-4.69-7.71-7.57-13.12-7.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m115.66,136.05h-5.52c-5.41,0-10.41,2.89-13.12,7.57l-2.76,4.78c-2.71,4.69-2.71,10.46,0,15.15l2.76,4.78c2.71,4.69,7.71,7.57,13.12,7.57h5.52c5.41,0,10.41-2.89,13.12-7.57l2.76-4.78c2.71-4.69,2.71-10.46,0-15.15l-2.76-4.78c-2.71-4.69-7.71-7.57-13.12-7.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m130.63,104.26l-74.52,70.91,41.59,19.36h71.2s-3.75-49.06-4.33-50.39-33.94-39.88-33.94-39.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m131.74,122.84c-10.75,24.43-35.42,40.27-64.65,53.25l36.08,14.53h61.77s-3.26-36.83-3.76-37.84-29.44-29.94-29.44-29.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m135.81,139.96c-8.82,18.18-26.15,30.68-48.4,39.86l27.01,10.88h46.24s-2.44-27.57-2.81-28.32-22.04-22.42-22.04-22.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m121.18,175.9h-16.56c-1.7,0-3.3-.78-4.34-2.08-.19-.22-.35-.46-.49-.71l-6.16-10.66-2.13-3.69c-1-1.72-1-3.85,0-5.58l8.28-14.35c1-1.73,2.84-2.79,4.83-2.79h16.56c.86,0,1.69.2,2.44.56.99.48,1.83,1.25,2.39,2.23l5.2,9.01,3.08,5.33c1,1.73,1,3.86,0,5.58l-8.28,14.35c-1,1.73-2.84,2.79-4.83,2.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m134.3,158.76l-8.28,14.35c-1,1.73-2.84,2.79-4.83,2.79h-16.56c-1.7,0-3.3-.78-4.34-2.08-.19-.22-.35-.46-.49-.71l-6.16-10.66c12.05-7.34,22.38-15.75,29.99-25.84.99.48,1.83,1.25,2.39,2.23l5.2,9.01,3.08,5.33c1,1.73,1,3.86,0,5.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m121.18,175.9h-16.56c-1.7,0-3.3-.78-4.34-2.08,12.99-6.86,23.63-15.3,30.94-25.97l3.08,5.33c1,1.73,1,3.86,0,5.58l-8.28,14.35c-1,1.73-2.84,2.79-4.83,2.79Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 3.68,
    y: 5.84,
    width: 200.58,
    height: 300.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 172.03,
    y: 128.49,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 179.66,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 164.39,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 136.18,
    y: 51.1,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 143.82,
    y: 58.39,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 14.84,
    y: 121.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 14.84,
    y: 266.13,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 7.21,
    y: 258.84,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 179.66,
    y: 266.13,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 136.18,
    y: 180.56,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 128.53,
    y: 187.85,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 22.49,
    y: 17.89,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 14.86,
    y: 25.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 73.35,
    y: 25.19,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 168.75,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 137.99,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-68",
    points: "3.68 168.75 3.68 143.83 204.26 143.83 204.26 168.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    y: 41.04,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    y: 300.15,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    y: 300.15,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.57,
    y: 59.44,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 27.59,
    y: 62.46,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.64 62.46 58.64 68.58 27.59 99.63 27.59 84.91 50.06 62.46 58.64 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.64 94.54 58.64 109.25 54.69 113.21 39.98 113.21 58.64 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.64 88.09 58.64 91.2 36.63 113.21 33.53 113.21 58.64 88.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "46.93 62.46 27.59 81.8 27.59 75.7 40.84 62.46 46.93 62.46"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.59,
    y: 77,
    width: 31.05,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.43,
    y: 59.44,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 88.45,
    y: 62.46,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.5 62.46 119.5 68.58 88.45 99.63 88.45 84.91 110.9 62.46 119.5 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.5 94.54 119.5 109.25 115.53 113.21 100.83 113.21 119.5 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.5 88.09 119.5 91.2 97.48 113.21 94.38 113.21 119.5 88.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.78 62.46 88.45 81.8 88.45 75.7 101.7 62.46 107.78 62.46"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.45,
    y: 77,
    width: 31.05,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 146.28,
    y: 59.44,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 149.3,
    y: 62.46,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.35 62.46 180.35 68.58 149.3 99.63 149.3 84.91 171.75 62.46 180.35 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.35 94.54 180.35 109.25 176.38 113.21 161.68 113.21 180.35 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.35 88.09 180.35 91.2 158.33 113.21 155.24 113.21 180.35 88.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "168.64 62.46 149.3 81.8 149.3 75.7 162.55 62.46 168.64 62.46"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 149.3,
    y: 77,
    width: 31.05,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.57,
    y: 13.41,
    width: 37.09,
    height: 20.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 27.59,
    y: 16.43,
    width: 31.05,
    height: 14.54
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.64 16.43 58.64 22.55 50.22 30.97 35.5 30.97 50.06 16.43 58.64 16.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "46.93 16.43 32.37 30.97 27.59 30.97 27.59 29.67 40.85 16.43 46.93 16.43"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.43,
    y: 13.41,
    width: 37.09,
    height: 20.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 88.45,
    y: 16.43,
    width: 31.05,
    height: 14.54
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.5 16.43 119.5 22.55 111.08 30.97 96.36 30.97 110.92 16.43 119.5 16.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.79 16.43 93.24 30.97 88.45 30.97 88.45 29.67 101.71 16.43 107.79 16.43"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 146.3,
    y: 13.41,
    width: 37.09,
    height: 20.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 149.31,
    y: 16.43,
    width: 31.05,
    height: 14.54
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.35 16.43 180.35 22.55 171.93 30.97 157.21 30.97 171.77 16.43 180.35 16.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "168.64 16.43 154.08 30.97 149.3 30.97 149.3 29.67 162.56 16.43 168.64 16.43"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 145.8,
    y: 197.66,
    width: 46.34,
    height: 108.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 152.69,
    y: 204.73,
    width: 32.55,
    height: 89.29
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.24 276.89 185.24 292.3 183.52 294.03 168.1 294.03 185.24 276.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.24 204.73 185.24 209.98 152.69 242.54 152.69 227.13 175.09 204.73 185.24 204.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.24 216.34 185.24 219.59 152.69 252.14 152.69 248.89 185.24 216.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.24 252.1 185.24 255.35 152.69 287.91 152.69 284.65 185.24 252.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.72 204.73 152.69 213.76 152.69 207.38 155.34 204.73 161.72 204.73"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 187.31,
    y: 260.48,
    width: 2.85,
    height: 9.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 152.69,
    y: 257.5,
    width: 32.55,
    height: 2.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.81,
    y: 197.66,
    width: 115.07,
    height: 87.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 18.67,
    y: 200.64,
    width: 109.35,
    height: 81.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 143.39,
    y: 197.79,
    width: 0.39,
    height: 27.83,
    transform: "translate(-31.09 24.82) rotate(-8.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m146.52,225.38c0,.41-.34.74-.76.74-.41,0-.74-.33-.74-.74,0-.41.33-.75.74-.76.42,0,.76.34.76.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 180.37,
    y: 211.48,
    width: 27.83,
    height: 0.39,
    transform: "translate(-44.82 371) rotate(-81.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m191.31,225.38c0,.41.34.74.76.74.41,0,.74-.33.74-.74,0-.41-.33-.75-.74-.76-.42,0-.76.34-.76.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m35.77,282.34c0-1.06-.86-1.91-1.91-1.91h-16.48c-1.06,0-1.91.86-1.91,1.91h0c0,1.06.86,1.91,1.91,1.91h16.48c1.06,0,1.91-.86,1.91-1.91h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 16.88,
    y: 275.05,
    width: 17.48,
    height: 7.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 20.5,
    y: 276.44,
    width: 10.24,
    height: 4.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m29.96,280.6h-8.68c-.08,0-.15-.07-.15-.15v-3.49c0-.08.07-.15.15-.15h8.68c.08,0,.15.07.15.15v3.49c0,.08-.07.15-.15.15Zm-8.53-.3h8.38v-3.2h-8.38v3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m16.88,274.11c.05-1.55,5.02-1.87,8.74-4.37,3.75,2.82,8.69,2.83,8.74,4.37h0v.94h-17.48v-.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m33.05,274.27h-14.86c-.07,0-.12-.05-.12-.12s.05-.12.12-.12h14.86c.07,0,.12.05.12.12s-.05.12-.12.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m23.36,264.92s.5.75.92,2.07c.14.43.27.89.27,1.38,0,.49-.16.95-.3,1.38-.42,1.31-.89,2.07-.89,2.07,0,1.25,4.51,1.25,4.51,0,0,0-.47-.76-.89-2.07-.14-.44-.29-.89-.3-1.38,0-.49.13-.95.27-1.38.42-1.32.92-2.07.92-2.07,0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m15.7,259.73c-1.29,0-2.79-.33-4-1.27-1.48-1.15-2.26-2.93-2.33-5.31-.06-2.02.48-3.45,1.6-4.27,1.74-1.26,4.14-.43,4.24-.4.39.14.59.57.46.96-.14.39-.57.59-.96.46-.03,0-1.78-.6-2.87.2-.69.51-1.02,1.52-.98,3.01.05,1.91.64,3.31,1.75,4.17,1.32,1.03,3.12,1.09,4.26.83.4-.09.81.16.9.57.09.4-.16.81-.57.9-.44.1-.96.16-1.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m35.48,259.73c-.56,0-1.07-.06-1.51-.16-.4-.09-.66-.49-.57-.9.09-.4.49-.66.9-.57,1.14.26,2.94.19,4.26-.83,1.11-.86,1.69-2.26,1.75-4.17.04-1.49-.29-2.5-.98-3.01-1.09-.8-2.85-.2-2.87-.2-.39.14-.82-.07-.95-.46-.14-.39.07-.82.46-.95.1-.04,2.51-.87,4.24.4,1.12.81,1.66,2.25,1.6,4.27-.07,2.38-.85,4.16-2.33,5.31-1.21.94-2.71,1.27-4,1.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m14.31,249.47v-3.02c0-1.24,1.01-2.25,2.25-2.25h18.06c.6,0,1.17.24,1.59.66.42.42.66.99.66,1.59v3.07c-.02,9.15-5.07,16.57-11.28,16.57s-11.28-7.45-11.28-16.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 25.56,
    cy: 255.15,
    r: 5.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m25.56,261.87c-3.71,0-6.72-3.02-6.72-6.72s3.02-6.72,6.72-6.72,6.72,3.02,6.72,6.72-3.02,6.72-6.72,6.72Zm0-13.15c-3.54,0-6.42,2.88-6.42,6.42s2.88,6.42,6.42,6.42,6.42-2.88,6.42-6.42-2.88-6.42-6.42-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.34,252.02c.03-.09.12-.16.21-.16s.18.06.21.16c.22.68.55,1.69.67,2.08.03.09.12.16.21.16h2.18c.1,0,.18.06.21.16.03.09,0,.19-.08.25-.58.42-1.44,1.05-1.77,1.28-.08.06-.11.16-.08.25.12.38.45,1.4.67,2.08.03.09,0,.19-.08.25-.08.06-.19.06-.26,0-.58-.42-1.44-1.05-1.77-1.28-.08-.06-.19-.06-.26,0-.33.24-1.19.86-1.77,1.28-.08.06-.19.06-.26,0-.08-.06-.11-.16-.08-.25.22-.68.55-1.69.67-2.08.03-.09,0-.19-.08-.25-.33-.24-1.19-.86-1.77-1.28-.08-.06-.11-.16-.08-.25.03-.09.12-.16.21-.16h2.18c.1,0,.18-.06.21-.16.12-.38.45-1.4.67-2.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.77,258.03c-.18,0-.34-.1-.42-.27-1.97-4.63-1.76-9.02-1.75-9.2.01-.25.23-.44.47-.43.25.01.44.23.43.47,0,.06-.2,4.38,1.68,8.8.1.23,0,.49-.24.59-.06.02-.12.04-.18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.79,261.59c-.14,0-.27-.06-.36-.18-.47-.63-.91-1.32-1.3-2.03-.12-.22-.04-.49.18-.61.22-.12.49-.04.61.18.37.68.78,1.33,1.23,1.93.15.2.11.48-.09.63-.08.06-.18.09-.27.09Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.6,245.44c0-.69-.56-1.24-1.24-1.24H14.76c-.69,0-1.24.56-1.24,1.24h0c0,.69.56,1.24,1.24,1.24h21.6c.69,0,1.24-.56,1.24-1.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m35.72,245.66H15.52c-.12,0-.22-.1-.22-.22s.1-.22.22-.22h20.2c.12,0,.22.1.22.22s-.1.22-.22.22Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m61.91,282.34c0-.51-.2-.99-.56-1.35-.36-.36-.84-.56-1.35-.56h-11.64c-.51,0-.99.2-1.35.56-.36.36-.56.84-.56,1.35h0c0,.51.2.99.56,1.35.36.36.84.56,1.35.56h11.64c.51,0,.99-.2,1.35-.56.36-.36.56-.84.56-1.35h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.68,277.73c.04-1.55,3.73-1.87,6.5-4.37,2.79,2.82,6.46,2.83,6.5,4.37h0v4.81h-13v-4.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m58.06,278.25c0-.17-.13-.3-.3-.3h-7.16c-.17,0-.3.13-.3.3v2.95c0,.17.13.3.3.3h7.16c.17,0,.3-.13.3-.3v-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m53.59,263.19l-.61,11.3c0,.66.54,1.2,1.2,1.2s1.2-.54,1.2-1.2l-.61-11.3c0-.33-.27-.59-.59-.59s-.59.27-.59.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m59,277.53h-9.64c-.17,0-.3-.13-.3-.3s.13-.3.3-.3h9.64c.17,0,.3.13.3.3s-.13.3-.3.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m50.89,255.49c-4.57-1.32-7.68-7.28-8.57-9.49-.89-2.21-1.52-6.22-.9-6.25.35,0,.95.03,1.26,0,.72,0,.13.59,1.16,2.51,1.51,2.81,4.49,3.14,4.49,3.14v-2.41s-2.57.54-3.68-1.73c-1.11-2.28-.42-3.24-1.14-3.22-1,.03-2.57.02-3.39,0-.94-.02.01,5.32.9,8.01.89,2.69,5.24,10.41,9.85,10.85.01-.47.02-.9.02-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m57.46,255.49c4.57-1.32,7.68-7.28,8.57-9.49.89-2.21,1.52-6.22.9-6.25-.35,0-.95.03-1.26,0-.72,0-.13.59-1.16,2.51-1.51,2.81-4.49,3.14-4.49,3.14v-2.41s2.57.54,3.68-1.73c1.11-2.28.42-3.24,1.14-3.22,1,.03,2.57.02,3.39,0,.94-.02-.01,5.32-.9,8.01-.89,2.69-5.24,10.41-9.85,10.85-.01-.47-.02-.9-.02-1.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m55.9,262.94c-.24.75-.94,1.26-1.73,1.26s-1.49-.51-1.73-1.26c-2.37-7.43-6.48-20.28-7.63-23.91-.07-.23-.03-.48.11-.67.14-.19.37-.31.61-.31h17.29c.24,0,.46.11.61.31.14.19.18.44.11.67-1.16,3.63-5.26,16.48-7.63,23.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m52.83,263.59l-5.5-25.55h1.38l5.47,26.15,5.47-26.15h1.38l-5.5,25.55c-.34.38-.82.6-1.35.6s-1.01-.23-1.35-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m61.79,239.26h-15.22c-.17,0-.3-.13-.3-.3s.13-.3.3-.3h15.22c.17,0,.3.13.3.3s-.13.3-.3.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m90.69,282.34c0-1.06-.86-1.91-1.91-1.91h-14.52c-1.06,0-1.91.86-1.91,1.91h0c0,1.06.86,1.91,1.91,1.91h14.52c1.06,0,1.91-.86,1.91-1.91h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m89.01,277.83c0-.41-.34-.75-.75-.75h-13.49c-.41,0-.75.34-.75.75v4.51h14.99v-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m85.08,278.32c0-.08-.03-.16-.09-.21-.06-.06-.13-.09-.21-.09h-6.53c-.08,0-.16.03-.21.09-.06.06-.09.13-.09.21v2.78c0,.08.03.16.09.21.06.06.13.09.21.09h6.53c.08,0,.16-.03.21-.09.06-.06.09-.13.09-.21v-2.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m86.65,243.62l3.4,2.69-8.53,10.03-8.53-10.03,3.4-2.69h10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m86.65,243.62l3.4,2.69-8.53,10.03-8.53-10.03,3.4-2.69h10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m81.52,256.34l-8.53-10.03h17.07l-8.53,10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m90.05,246.31h-17.07l3.4-2.69h10.27l3.4,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m81.22,243.62l-3.23,2.69-1.6-2.69h4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m86.65,243.62l-1.6,2.69-3.83-2.69h5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m85.05,246.31l-3.53,10.03-3.53-10.03h7.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m87.47,277.08c0-.46-.18-.9-.51-1.22-.32-.32-.76-.51-1.22-.51h-8.45c-.46,0-.9.18-1.22.51-.32.32-.51.77-.51,1.22h0s11.91,0,11.91,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m85.37,273.99c0-.21-.17-.37-.38-.37h-6.95c-.21,0-.37.17-.37.37v1.36h7.7v-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m76.09,254.74h10.86l-2.71,18.87h-5.43l-2.71-18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m78.8,254.74h5.43l-1.36,18.87h-2.71l-1.36-18.87Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m112.76,282.34c0-1.06-.86-1.91-1.91-1.91h-14.52c-1.06,0-1.91.86-1.91,1.91h0c0,1.06.86,1.91,1.91,1.91h14.52c1.06,0,1.91-.86,1.91-1.91h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m99.34,264.77c-2.69-1.72-4.51-5.02-4.51-8.81v-.94c0-1.24,1.01-2.25,2.25-2.25h13.02c.6,0,1.17.24,1.59.66.42.42.66.99.66,1.59v.97c-.01,3.77-1.83,7.06-4.51,8.77h.03s-3.52,2.4-3.4,6.52c.15,5.3,1.02,5.63,2.54,6.86,1.07.86,3.4,1.3,3.43,2.3h0v.94h-13.69v-.94h0c.03-.98,2.43-1.38,3.45-2.32,1.41-1.31,2.37-1.85,2.51-6.84.12-4.12-3.4-6.52-3.4-6.52h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m98.2,252.77c-.09.55-.18,1.37-.2,2.39-.02.94.02,2.05.18,3.28.14,1.1.54,2.09,1.05,3.02,1.32,2.39,3.34,4.39,3.84,6.82.16.73.27,1.48.35,2.22.12,1.16.15,2.32.08,3.38-.11,1.49-.42,2.81-.94,3.71-.95,1.68-2.04,2.22-2.74,3.01-.19.22-.34.46-.44.78h-1.21c.19-.67.49-1.12.9-1.5.74-.7,1.83-1.13,2.87-2.67.54-.81.9-2,1.06-3.38.1-.87.13-1.8.08-2.75-.05-.91-.19-1.83-.39-2.73-.65-2.71-3.23-4.82-4.57-7.59-.33-.69-.6-1.42-.74-2.21-.23-1.27-.34-2.42-.37-3.4-.03-.99,0-1.81.05-2.4h.03s1.12,0,1.12,0Zm10.84,0h1.05s.07,0,.1,0c.05.59.09,1.41.05,2.4-.03.98-.14,2.13-.37,3.4-.14.79-.41,1.52-.74,2.21-1.34,2.77-3.92,4.87-4.57,7.59-.2.89-.33,1.82-.39,2.73-.06.95-.03,1.88.08,2.75.16,1.37.52,2.57,1.06,3.38,1.05,1.54,2.14,1.97,2.87,2.67.4.38.71.83.9,1.5h-1.21c-.1-.31-.24-.56-.44-.78-.7-.79-1.78-1.33-2.74-3.01-.53-.91-.84-2.22-.94-3.71-.08-1.06-.05-2.22.08-3.38.08-.75.19-1.49.35-2.22.5-2.43,2.52-4.43,3.84-6.82.51-.93.9-1.92,1.05-3.02.16-1.23.2-2.34.18-3.28-.02-1.02-.12-1.84-.2-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m110.22,254.08h-13.25c-.21,0-.38-.17-.38-.37s.17-.37.38-.37h13.25c.21,0,.38.17.38.37s-.17.37-.38.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m109.41,280.62h-11.63c-.07,0-.13-.06-.13-.13s.06-.13.13-.13h11.63c.07,0,.13.06.13.13s-.06.13-.13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m103.5,256.41c.03-.09.12-.16.21-.16s.18.06.21.16c.18.55.42,1.3.52,1.61.03.09.12.16.21.16h1.7c.1,0,.18.06.21.16.03.09,0,.19-.08.25-.47.34-1.1.8-1.37,1-.08.06-.11.16-.08.25.1.32.35,1.06.52,1.61.03.09,0,.19-.08.25s-.19.06-.26,0c-.47-.34-1.1-.8-1.37-1-.08-.06-.19-.06-.26,0-.27.2-.9.66-1.37,1-.08.06-.19.06-.26,0-.08-.06-.11-.16-.08-.25.18-.55.42-1.3.52-1.61.03-.09,0-.19-.08-.25-.27-.2-.9-.66-1.37-1-.08-.06-.11-.16-.08-.25.03-.09.12-.16.21-.16h1.7c.1,0,.18-.06.21-.16.1-.32.35-1.06.52-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m111.59,281.97c0-.15-.06-.3-.17-.41-.11-.11-.25-.17-.41-.17h-14.85c-.15,0-.3.06-.41.17-.11.11-.17.25-.17.41h0c0,.15.06.3.17.41.11.11.25.17.41.17h14.85c.15,0,.3-.06.41-.17.11-.11.17-.25.17-.41h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m134.83,282.34c0-1.06-.86-1.91-1.91-1.91h-14.52c-1.06,0-1.91.86-1.91,1.91h0c0,1.06.86,1.91,1.91,1.91h14.52c1.06,0,1.91-.86,1.91-1.91h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 125.66,
    cy: 248.66,
    r: 7.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m125.66,255.59c-3.77,0-6.84-3.07-6.84-6.84s3.07-6.84,6.84-6.84,6.84,3.07,6.84,6.84-3.07,6.84-6.84,6.84Zm0-13.28c-3.55,0-6.44,2.89-6.44,6.44s2.89,6.44,6.44,6.44,6.44-2.89,6.44-6.44-2.89-6.44-6.44-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m125.45,243.28c.03-.09.12-.16.21-.16s.18.06.21.16c.32.97.89,2.73,1.06,3.26.03.09.12.16.21.16h3.43c.1,0,.18.06.21.16.03.09,0,.19-.08.25-.83.6-2.32,1.69-2.77,2.02-.08.06-.11.16-.08.25.17.53.74,2.29,1.06,3.26.03.09,0,.19-.08.25-.08.06-.19.06-.26,0-.83-.6-2.32-1.69-2.77-2.01-.08-.06-.19-.06-.26,0-.45.33-1.95,1.41-2.77,2.01-.08.06-.19.06-.26,0-.08-.06-.11-.16-.08-.25.32-.97.89-2.73,1.06-3.26.03-.09,0-.19-.08-.25-.45-.33-1.95-1.41-2.77-2.02-.08-.06-.11-.16-.08-.25.03-.09.12-.16.21-.16h3.43c.1,0,.18-.06.21-.16.17-.53.74-2.29,1.06-3.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m118.5,282.34s0-2.89,0-4.81c0-.6.29-1.15.79-1.49,1.32-.9,3.85-2.83,4.18-4.54.6-3.07.04-10.29-1.39-13.39-.73-1.57-3.61-3.9-5.04-5-.12-.1-.17-.26-.12-.41.05-.15.19-.25.35-.25,3.61-.04,6.17,1.24,8.4,1.2h.05c2.22.02,4.77-1.24,8.35-1.2.16,0,.3.1.35.25.05.15,0,.31-.12.41-1.44,1.1-4.32,3.43-5.04,5-1.43,3.09-1.99,10.31-1.39,13.39.33,1.71,2.87,3.64,4.18,4.54.49.34.79.89.79,1.49,0,1.92,0,4.81,0,4.81h-14.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m129.67,252.98c-.7,1.16-1.98,3.62-2.31,5.14-.68,3.09-.94,10.31-.66,13.39.16,1.71,1.36,3.64,1.98,4.54.23.33.37.89.37,1.49,0,1.92,0,4.81,0,4.81h-6.77s0-2.89,0-4.81c0-.6.14-1.15.37-1.49.62-.9,1.82-2.83,1.98-4.54.28-3.07.02-10.29-.66-13.39-.33-1.52-1.61-3.98-2.31-5.14,1.51.33,2.81.69,4.01.67h.05c1.19.01,2.47-.34,3.96-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m117.55,253.23s1.21.07,2.43.25c.57.09,1.13.2,1.58.34.74.23,1.51.42,2.31.54.76.11,1.55.16,2.37.11.34-.02.78-.1,1.29-.21.27-.06.55-.12.84-.19.6-.14,1.24-.3,1.88-.45.43-.1.85-.19,1.26-.27.88-.17,1.67-.26,2.23-.19.12.01.23-.08.25-.2.01-.12-.08-.23-.2-.25-.42-.03-.97.04-1.58.17-.91.19-1.97.5-2.98.79-.52.15-1.02.29-1.48.4-.59.14-1.11.24-1.5.26-.81.03-1.59-.03-2.33-.16-.79-.14-1.54-.36-2.25-.61-.45-.16-1.03-.3-1.61-.41-1.23-.24-2.45-.36-2.45-.36-.12,0-.23.08-.24.21,0,.12.08.23.21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m131.69,276.58h-12.05c-.12-.01-.22-.11-.22-.24,0-.12.1-.22.23-.22h12.05c.12.01.22.11.22.24,0,.12-.1.22-.23.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m133.16,277.83c0-.41-.34-.75-.75-.75h-13.49c-.41,0-.75.34-.75.75v4.51h14.99v-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m129.05,278.32c0-.17-.13-.3-.3-.3h-6.17c-.17,0-.3.13-.3.3v2.78c0,.17.13.3.3.3h6.17c.17,0,.3-.13.3-.3v-2.78Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m197.12,197.68h-56.42c3.17-5.28,5.4-11.07,6.59-17.12h43.25c1.19,6.04,3.42,11.83,6.59,17.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m197.12,197.68v2.03c.02.97-.74,1.77-1.71,1.82h-3.64c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.65c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.65c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.64c.12-.94-.55-1.81-1.49-1.93-.94-.12-1.81.55-1.93,1.49-.02.14-.02.29,0,.44h-3.64c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.61c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.65c.08-.94-.61-1.77-1.55-1.86-.94-.08-1.77.61-1.86,1.55,0,.1,0,.2,0,.31h-3.64c-.99-.04-1.75-.88-1.71-1.87,0,0,0,0,0,0v-2.03l56.38.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 18.67,
    y: 200.64,
    width: 109.35,
    height: 81.48
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.02 250.42 128.02 265.83 111.73 282.12 96.31 282.12 128.02 250.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "82.64 200.64 18.67 264.6 18.67 249.18 67.23 200.64 82.64 200.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "92.24 200.64 18.67 274.19 18.67 270.94 88.99 200.64 92.24 200.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.02 225.63 128.02 228.86 74.77 282.12 71.52 282.12 128.02 225.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.02 271.7 128.02 278.08 123.98 282.12 117.6 282.12 128.02 271.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.86 200.64 18.67 235.82 18.67 229.44 47.48 200.64 53.86 200.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m16.04,152.99v6.04h-2.27v-.8c-.31.56-.91.9-1.73.9-1.57,0-2.7-1.16-2.7-3.12s1.13-3.12,2.7-3.12c.8,0,1.39.34,1.73.89v-.79h2.27Zm-3.36,4.38c.59,0,1.05-.48,1.05-1.36,0-.87-.46-1.36-1.05-1.36s-1.07.45-1.07,1.36.44,1.36,1.07,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.01,152.89c1.86,0,3.17.88,3.32,2.62h-2.32c-.09-.59-.47-.88-1-.88-.64,0-1.09.47-1.09,1.39s.44,1.39,1.09,1.39c.53,0,.91-.3,1-.88h2.32c-.15,1.74-1.46,2.62-3.32,2.62-2.03,0-3.36-1.06-3.36-3.13s1.33-3.13,3.36-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.21,154.58c-.56,0-.96.45-.96,1.03v3.42h-2.27v-8h2.27v2.71c.29-.55.94-.86,1.66-.86.97,0,1.64.31,2.02.9.27.4.41.92.41,1.56v3.69h-2.27v-3.46c0-.67-.3-.99-.87-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.35,150.33c.79,0,1.3.49,1.3,1.1s-.51,1.1-1.3,1.1-1.31-.49-1.31-1.1.52-1.1,1.31-1.1Zm1.13,8.71h-2.27v-6.04h2.27v6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.53,154.58c.24.52.34,1.15.3,1.83h-4.38c.1.69.51,1.05,1.06,1.05.45,0,.84-.2.96-.73h2.26c-.22,1.6-1.54,2.4-3.22,2.4-2.03,0-3.36-1.06-3.36-3.13s1.33-3.13,3.37-3.13c1.49,0,2.54.65,3.02,1.7Zm-2.03.76c-.01-.05-.02-.11-.04-.16-.14-.46-.48-.7-.95-.7-.51,0-.87.29-1.02.86h2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.28,152.99l1.13,3.75,1.13-3.75h2.52l-2.31,6.04h-2.68l-2.3-6.04h2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m54.37,154.58c.24.52.34,1.15.3,1.83h-4.38c.1.69.51,1.05,1.06,1.05.45,0,.84-.2.96-.73h2.26c-.22,1.6-1.54,2.4-3.22,2.4-2.03,0-3.36-1.06-3.36-3.13s1.33-3.13,3.37-3.13c1.49,0,2.54.65,3.02,1.7Zm-2.03.76c-.01-.05-.02-.11-.04-.16-.14-.46-.48-.7-.95-.7-.51,0-.87.29-1.02.86h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m58.39,154.58c-.47,0-.82.41-.82,1.02v3.43h-2.27v-6.04h2.27v.73c.27-.52.85-.83,1.54-.83,1.03,0,1.71.38,2.05,1.1.28-.66.82-1.1,1.77-1.1s1.56.3,1.93.86c.27.4.4.93.4,1.59v3.7h-2.27v-3.46c0-.3-.05-.53-.15-.69-.13-.2-.33-.3-.61-.3-.44,0-.81.44-.81,1.02v3.43h-2.27v-3.46c0-.68-.26-.99-.76-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m72.31,154.58c.24.52.34,1.15.3,1.83h-4.38c.1.69.51,1.05,1.06,1.05.45,0,.84-.2.96-.73h2.26c-.22,1.6-1.54,2.4-3.22,2.4-2.03,0-3.36-1.06-3.36-3.13s1.33-3.13,3.37-3.13c1.49,0,2.54.65,3.02,1.7Zm-2.03.76c-.01-.05-.02-.11-.04-.16-.14-.46-.48-.7-.95-.7-.51,0-.87.29-1.02.86h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m77.1,154.82c-.15-.16-.36-.24-.64-.24-.56,0-.96.44-.96,1.02v3.43h-2.27v-6.04h2.27v.75c.29-.53.92-.86,1.66-.86s1.33.19,1.74.54c.47.41.7,1.06.7,1.92v3.69h-2.27v-3.46c0-.34-.08-.59-.23-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m83.31,152.99h1.59v1.77h-1.59v1.76c0,.55.19.78.6.78h.99v1.74s-2.03,0-2.03,0c-1.24,0-1.83-.7-1.83-1.92v-2.35h-1v-1.77h.55c.33,0,.39-.18.46-.51l.15-.87h2.13v1.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m143.09,154.24c-.48,0-.77.18-.75.43.03.31.44.49,1.17.61,1.9.31,2.68.71,2.67,1.84,0,1.32-1.3,2.02-3.16,2-1.86,0-3.08-.6-3.03-2.04h2.2c-.05.37.33.64.87.64s.83-.21.79-.52c-.05-.34-.83-.47-1.89-.7-1.23-.27-1.93-.83-1.93-1.85,0-1.2,1.2-1.8,3.01-1.78,1.66,0,3.01.62,2.97,1.94h-2.2c.02-.37-.27-.59-.72-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m150.02,154.58c-.56,0-.96.45-.96,1.03v3.42h-2.27v-8h2.27v2.71c.29-.55.94-.86,1.66-.86.97,0,1.64.31,2.02.9.27.4.41.92.41,1.56v3.69h-2.27v-3.46c0-.67-.3-.99-.87-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m153.81,156.01c0-2.07,1.33-3.13,3.36-3.13s3.33,1.06,3.33,3.13-1.33,3.13-3.33,3.13-3.36-1.06-3.36-3.13Zm3.36,1.42c.62,0,1.07-.47,1.07-1.42,0-.94-.45-1.42-1.07-1.42s-1.09.47-1.09,1.42.44,1.42,1.09,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m170.27,152.99l-1.8,6.04h-2.37l-.75-3.21-.75,3.21h-2.36l-1.8-6.04h2.34l.86,3.47.71-3.47h2l.71,3.48.86-3.48h2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m173.02,155.83v3.2h-2.27v-6.04h2.27v.69c.33-.53.92-.8,1.65-.8v1.73c-1.14-.09-1.64.48-1.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m174.83,156.01c0-2.07,1.33-3.13,3.36-3.13s3.33,1.06,3.33,3.13-1.33,3.13-3.33,3.13-3.36-1.06-3.36-3.13Zm3.36,1.42c.62,0,1.07-.47,1.07-1.42,0-.94-.45-1.42-1.07-1.42s-1.09.47-1.09,1.42.44,1.42,1.09,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m182.03,156.01c0-2.07,1.33-3.13,3.36-3.13s3.33,1.06,3.33,3.13-1.33,3.13-3.33,3.13-3.36-1.06-3.36-3.13Zm3.36,1.42c.62,0,1.07-.47,1.07-1.42,0-.94-.45-1.42-1.07-1.42s-1.09.47-1.09,1.42.44,1.42,1.09,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m192.44,154.58c-.47,0-.82.41-.82,1.02v3.43h-2.27v-6.04h2.27v.73c.27-.52.85-.83,1.54-.83,1.03,0,1.71.38,2.05,1.1.28-.66.82-1.1,1.77-1.1s1.56.3,1.93.86c.27.4.4.93.4,1.59v3.7h-2.27v-3.46c0-.3-.05-.53-.15-.69-.13-.2-.33-.3-.61-.3-.44,0-.81.44-.81,1.02v3.43h-2.27v-3.46c0-.68-.26-.99-.76-.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m121.18,177.5h-16.56c-2.56,0-4.94-1.38-6.22-3.59l-8.28-14.35c-1.28-2.22-1.28-4.97,0-7.18l8.28-14.35c1.28-2.22,3.66-3.59,6.22-3.59h16.56c2.56,0,4.94,1.38,6.22,3.59l8.28,14.35c1.28,2.22,1.28,4.97,0,7.18l-8.28,14.35c-1.28,2.22-3.66,3.59-6.22,3.59Zm-16.56-39.85c-1.42,0-2.74.76-3.45,1.99l-8.28,14.35c-.71,1.23-.71,2.75,0,3.98l8.28,14.35c.71,1.23,2.03,1.99,3.45,1.99h16.56c1.42,0,2.74-.76,3.45-1.99l8.28-14.35c.71-1.23.71-2.75,0-3.98l-8.28-14.35c-.71-1.23-2.03-1.99-3.45-1.99h-16.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 90.51,
    y: 136.05,
    width: 0.25,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 90.76,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 91.68,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 92.6,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 93.52,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 94.45,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 95.37,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 96.29,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 97.22,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.14,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 99.06,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 99.98,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 100.91,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 101.83,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 102.75,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.67,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 104.6,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 105.52,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 106.44,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 107.37,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 108.29,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 109.21,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 110.13,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 111.06,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.98,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 112.9,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 113.82,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 114.75,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 115.67,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 116.59,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 117.52,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 118.44,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 119.36,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 120.28,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 121.21,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 122.13,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 123.05,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 123.97,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 124.9,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 125.82,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 126.74,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 127.67,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 128.59,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 129.51,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 130.43,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 131.36,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 132.28,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 133.2,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 134.12,
    y: 136.05,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 135.05,
    y: 136.05,
    width: 0.25,
    height: 39.85
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m121.18,177.5h-16.56c-2.56,0-4.94-1.38-6.22-3.59l-8.28-14.35c-1.28-2.22-1.28-4.97,0-7.18l8.28-14.35c1.28-2.22,3.66-3.59,6.22-3.59h16.56c2.56,0,4.94,1.38,6.22,3.59l8.28,14.35c1.28,2.22,1.28,4.97,0,7.18l-8.28,14.35c-1.28,2.22-3.66,3.59-6.22,3.59Zm-16.56-39.85c-1.42,0-2.74.76-3.45,1.99l-8.28,14.35c-.71,1.23-.71,2.75,0,3.98l8.28,14.35c.71,1.23,2.03,1.99,3.45,1.99h16.56c1.42,0,2.74-.76,3.45-1.99l8.28-14.35c.71-1.23.71-2.75,0-3.98l-8.28-14.35c-.71-1.23-2.03-1.99-3.45-1.99h-16.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 56.11,
    y: 104.26,
    width: 0,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 56.11,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 58.46,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 60.81,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 63.16,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 65.51,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 67.86,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 70.21,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 72.56,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.91,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 77.26,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 79.61,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 81.96,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 84.31,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 86.66,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.01,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 91.36,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 93.71,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 96.06,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 98.41,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 100.76,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 103.11,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 105.46,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 107.81,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.16,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 112.51,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 114.86,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 117.21,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 119.55,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 121.9,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 124.25,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 126.6,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 128.95,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 131.3,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 133.65,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 136,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 138.35,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 140.7,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 143.05,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 145.4,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 147.75,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 150.1,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 152.45,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.8,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 157.15,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 159.5,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 161.85,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 164.2,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 166.55,
    y: 104.26,
    width: 2.35,
    height: 90.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 168.9,
    y: 104.26,
    width: 0,
    height: 90.27
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 67.09,
    y: 122.84,
    width: 0,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 67.09,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 69.13,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 71.17,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 73.21,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 75.25,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 77.29,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 79.33,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 81.36,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83.4,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 85.44,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 87.48,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.52,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 91.56,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 93.6,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.63,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 97.67,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 99.71,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 101.75,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 103.79,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 105.83,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 107.86,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 109.9,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 111.94,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.98,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 116.02,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 118.06,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 120.1,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 122.13,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 124.17,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 126.21,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 128.25,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 130.29,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 132.33,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 134.37,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 136.4,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 138.44,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 140.48,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 142.52,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 144.56,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 146.6,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 148.64,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 150.67,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.71,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 154.75,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 156.79,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 158.83,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 160.87,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 162.91,
    y: 122.84,
    width: 2.04,
    height: 67.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 164.94,
    y: 122.84,
    width: 0,
    height: 67.78
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 87.42,
    y: 139.96,
    width: 0,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 87.42,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 88.94,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 90.47,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 92,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 93.52,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 95.05,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 96.57,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 98.1,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.63,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 101.15,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 102.68,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 104.2,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 105.73,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 107.26,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.78,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 110.31,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 111.83,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 113.36,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 114.89,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 116.41,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 117.94,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 119.46,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 120.99,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122.52,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 124.04,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 125.57,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 127.09,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 128.62,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 130.15,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 131.67,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 133.2,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 134.73,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 136.25,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 137.78,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 139.3,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 140.83,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 142.36,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 143.88,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 145.41,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 146.93,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 148.46,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 149.99,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.51,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 153.04,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 154.56,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 156.09,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 157.62,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 159.14,
    y: 139.96,
    width: 1.53,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 160.67,
    y: 139.96,
    width: 0,
    height: 50.74
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 90.51,
    y: 136.04,
    width: 0.25,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 90.76,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 91.68,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 92.6,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 93.52,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 94.45,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 95.37,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 96.29,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 97.22,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.14,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 99.06,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 99.98,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 100.91,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 101.83,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 102.75,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.67,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 104.6,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 105.52,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 106.44,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 107.37,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 108.29,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 109.21,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 110.13,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 111.06,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.98,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 112.9,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 113.82,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 114.75,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 115.67,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 116.59,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 117.52,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 118.44,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 119.36,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 120.28,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 121.21,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 122.13,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 123.05,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 123.97,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 124.9,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 125.82,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 126.74,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 127.67,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 128.59,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 129.51,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 130.43,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 131.36,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 132.28,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 133.2,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 134.12,
    y: 136.04,
    width: 0.92,
    height: 39.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 135.05,
    y: 136.04,
    width: 0.25,
    height: 39.85
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 93.63,
    y: 136.61,
    width: 0,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 93.63,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 94.49,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 95.36,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 96.22,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 97.08,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 97.95,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 98.81,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 99.67,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.53,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 101.4,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 102.26,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 103.12,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 103.99,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 104.85,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.71,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 106.57,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 107.44,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 108.3,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 109.16,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 110.02,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 110.89,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 111.75,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 112.61,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.48,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 114.34,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 115.2,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 116.06,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 116.93,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 117.79,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 118.65,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 119.52,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 120.38,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 121.24,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 122.1,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 122.97,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 123.83,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 124.69,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 125.56,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 126.42,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 127.28,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 128.14,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 129.01,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 129.87,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 130.73,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 131.6,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 132.46,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 133.32,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 134.18,
    y: 136.61,
    width: 0.86,
    height: 39.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 135.05,
    y: 136.61,
    width: 0.25,
    height: 39.29
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 100.28,
    y: 147.85,
    width: 0,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 100.28,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 101,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 101.73,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 102.45,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 103.18,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 103.9,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 104.63,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 105.35,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.07,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 106.8,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 107.52,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 108.25,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 108.97,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 109.7,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.42,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.15,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 111.87,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 112.59,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 113.32,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 114.04,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 114.77,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 115.49,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 116.22,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.94,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 117.66,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 118.39,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 119.11,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 119.84,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 120.56,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 121.29,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 122.01,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 122.73,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 123.46,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 124.18,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 124.91,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 125.63,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 126.36,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 127.08,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 127.8,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 128.53,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 129.25,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 129.98,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 130.7,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 131.43,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 132.15,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 132.87,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 133.6,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 134.32,
    y: 147.85,
    width: 0.72,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 135.05,
    y: 147.85,
    width: 0.25,
    height: 28.05
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m134.3,158.76l-8.28,14.35c-1,1.73-2.84,2.79-4.83,2.79h-16.56c-1.7,0-3.3-.78-4.34-2.08-.19-.22-.35-.46-.49-.71l-6.16-10.66-2.13-3.69c-1-1.72-1-3.85,0-5.58l8.28-14.35c1-1.73,2.84-2.79,4.83-2.79h16.56c.86,0,1.69.2,2.44.56.99.48,1.83,1.25,2.39,2.23l5.2,9.01,3.08,5.33c1,1.73,1,3.86,0,5.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-45",
    width: 84,
    height: 80,
    transform: "translate(99.63 143.44) scale(.32)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m113.58,145.55l2.91,5.95c.11.22.32.38.57.42l6.56.93c.62.09.87.85.42,1.29l-4.76,4.61c-.18.17-.26.43-.22.67l1.14,6.52c.11.62-.54,1.09-1.1.8l-5.85-3.1c-.22-.12-.49-.12-.71,0l-5.85,3.1c-.55.29-1.2-.18-1.1-.8l1.14-6.52c.04-.25-.04-.5-.22-.67l-4.76-4.61c-.45-.44-.2-1.2.42-1.29l6.56-.93c.25-.04.46-.19.57-.42l2.91-5.95c.28-.56,1.08-.56,1.36,0Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementShowroom);
export default __webpack_public_path__ + "static/media/achievement-showroom.38e855a8fb99c6b23ba37a741ed1edb4.svg";
export { ForwardRef as ReactComponent };